import { Location } from '@angular/common'
import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { NomadeService } from '../../../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../../../services'
import { FormDialogComponent } from '../../../dialogs/form-dialog/form-dialog.component'
import { StateService } from '../../../../../../../services/App/state.service'
import { takeUntil } from 'rxjs/operators'
import { from, Subject } from 'rxjs'
import { ConfirmComponent } from '../../../../../layout/dialogs/confirm-dialog/confirm.component'
import { DocumentDialogComponent } from '../../../dialogs/document-dialog/document-nomade-dialog.component'
import { environment } from '../../../../../../../../environments/environment'
import { I } from '@angular/cdk/keycodes'

@Component({
	selector: 'atyl-nomade-dossier-documents',
	templateUrl: './nomade-dossier-documents.component.html',
	styleUrls: ['./nomade-dossier-documents.component.scss']
})
export class NomadeDossierDocumentsComponent {
	@Input() dossier: any;
    @Input() totalFilesSize: any;
    //stockage max d'import de fichiers et d'ajouts de fichiers
    maxFilesSize = environment.limitTotalFileSize;
	constructor(
		private nomadeService: NomadeService,
		private dialogService: DialogService,
	) { }

	ngOnInit() {

	}

    deleteDoc(event: Event, nomadeDoc: any) {
        event.stopPropagation();
        const dialogRef = this.dialogService.open(ConfirmComponent, {
            width: '250px',
            data : {
                libelle : 'Etes-vous sur de vouloir supprimer ce document ?'
            }
        });
    
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log("requete supprimée",nomadeDoc.request)
                this.nomadeService.deleteRequest(nomadeDoc.idRequest);
            }
        });
    }

    openDocumentModal(document: any = null){
        var modifyMode = document != null;
        const dialogRef = this.dialogService.open(DocumentDialogComponent, {
            data : {
                document: document,
                totalFilesSize: this.totalFilesSize
            },
            maximizable: true,
            minimizable: true,
            draggable: true,
            resizable: true,
            width:"32vw"
        })
        dialogRef.afterClosed().subscribe(document => {
            if(document){
                document.value.description = document.value.description ? document.value.description.replace(/<[^>]*>/g, '') : '';
                this.addDocumentRequest(document,modifyMode);
            }
          });
    }

    addDocumentRequest(document: any, modifyMode){
        var params = {
            documents: [
                {
                    demandeid: 0,
                    desciption: null,
                    document: {
                        ID: 0,
                        mendatory: false,
                        orign: "demande",
                        parameter: document.type.parameter,
                        type: document.type,
                        status: "0",
                        value: document.value
                    }
                }
            ],
            options: {
                demande: 0,
                demande_type: "DOSSIER",
                dossier: this.dossier.id
            }
            
        }
        
        let request = {
            method: 'webservice.document:setFromNomade',
			params: params
		}
        if(modifyMode){
            this.nomadeService.updateRequest(request,document.idRequest);
            console.log("modif doc req",request);
        }
        else{
            this.nomadeService.addRequest(request);
            console.log("new doc req",request)
        }
    }

    downloadDocument(doc) {
        console.log("Doc download",doc);
        const base64 = this.getBase64(doc.base64);
        const decoded = atob(base64);
        const byteArray = new Uint8Array(decoded.length);
        for (let i = 0; i < decoded.length; i++) {
          byteArray[i] = decoded.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: doc.mime });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = doc.value.file;
        link.click();
        URL.revokeObjectURL(url);
    }

    getBase64(dataUrl) {
        const regex = /^data:.+;base64,(.+)$/;
        const matches = dataUrl.match(regex);
        if (!matches || matches.length < 2) {
          throw new Error('Invalid data URL');
        }
        return matches[1];
    }

}
